const { io } = require('socket.io-client');

class WebSocketClient {

    /**
     * Create a WebScoketClient object to communicate with web socket server
     */
    constructor({
        url,
        query,
        onInterimTranscript = console.log,
        onTranscript = console.log,
        onError = console.error,
    }) {
        this.socket = io(url, { query });
        this.socket.on('connect', this.onConnection);
        this.socket.on('disconnect', () => {
            console.error('ws::WEBSOCKET_DISCONNECTED');
            onError('WEBSOCKET_DISCONNECTED');
        });
        this.socket.on('INTERIM_TRANSCRIPT', onInterimTranscript);
        this.socket.on('TRANSCRIPT', onTranscript);
    }

    onConnection = () => console.log('ws::Connected to server');

    sendBinary = (binaryData) => this.socket.emit('BINARY_DATA', binaryData);

    start = () => this.socket.emit('START_GSR');

    end = () => this.socket.emit('END_GSR');
}

module.exports = WebSocketClient;